/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AICategoryMiniReference,
    AICategoryMiniReferenceFromJSON,
    AICategoryMiniReferenceFromJSONTyped,
    AICategoryMiniReferenceToJSON,
    AIImageReference,
    AIImageReferenceFromJSON,
    AIImageReferenceFromJSONTyped,
    AIImageReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AIAnnotation
 */
export interface AIAnnotation {
    /**
     * 
     * @type {string}
     * @memberof AIAnnotation
     */
    id: string;
    /**
     * 
     * @type {AIImageReference}
     * @memberof AIAnnotation
     */
    image: AIImageReference;
    /**
     * 
     * @type {AICategoryMiniReference}
     * @memberof AIAnnotation
     */
    category: AICategoryMiniReference;
    /**
     * 
     * @type {string}
     * @memberof AIAnnotation
     */
    readonly assetDisplayName: string;
    /**
     * 
     * @type {string}
     * @memberof AIAnnotation
     */
    readonly transforms: string;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotation
     */
    relativeLeft: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotation
     */
    relativeTop: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotation
     */
    relativeWidth: number;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotation
     */
    relativeHeight: number;
    /**
     * 
     * @type {string}
     * @memberof AIAnnotation
     */
    track?: string;
    /**
     * 
     * @type {Date}
     * @memberof AIAnnotation
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {number}
     * @memberof AIAnnotation
     */
    createdBy?: number | null;
}

export function AIAnnotationFromJSON(json: any): AIAnnotation {
    return AIAnnotationFromJSONTyped(json, false);
}

export function AIAnnotationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AIAnnotation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'image': AIImageReferenceFromJSON(json['image']),
        'category': AICategoryMiniReferenceFromJSON(json['category']),
        'assetDisplayName': json['asset_display_name'],
        'transforms': json['transforms'],
        'relativeLeft': json['relative_left'],
        'relativeTop': json['relative_top'],
        'relativeWidth': json['relative_width'],
        'relativeHeight': json['relative_height'],
        'track': !exists(json, 'track') ? undefined : json['track'],
        'createdAt': (new Date(json['created_at'])),
        'createdBy': !exists(json, 'created_by') ? undefined : json['created_by'],
    };
}

export function AIAnnotationToJSON(value?: AIAnnotation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'image': AIImageReferenceToJSON(value.image),
        'category': AICategoryMiniReferenceToJSON(value.category),
        'relative_left': value.relativeLeft,
        'relative_top': value.relativeTop,
        'relative_width': value.relativeWidth,
        'relative_height': value.relativeHeight,
        'track': value.track,
        'created_by': value.createdBy,
    };
}


